export const customStyles = {
    content: {
      margin:"0 auto",
      width:"75%",
      padding:"15px",
      position:"absolute",
      textAlign: "center",
      backgroundColor:"#97AEC3",
      borderRadius:"15px",
      border:"none",
      boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 15px",
      zIndex: "1000",
    },
    overlay:{
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      backgroundColor:"rgb(86, 100, 117,0.4)",
      zIndex: "1000",
      overflow:"auto"
    }

};